// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.q75caQFkGHgoxdMk {
	display: flex;
	gap: var(--lok-spacing-7);
	padding: var(--lok-spacing-7);
}

.BVc_Eh0Ty2k_vSPL {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-6);
	flex: 1;
}

.Xp1eN7zzigcc_eVh {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-4);
}

.swWIjXp63JI1F3oo {
	font: var(--lok-typography-heading-3);
	font-family: var(--lok-font-family-inter);
}

._2Z1GwAfS_QavHFZ {
	font: var(--lok-typography-body-small-default);
	font-family: var(--lok-font-family-inter);
}

.fCX4XNQTaUcXOPRh {
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	gap: var(--lok-spacing-3);
	height: 100%;
}

.GWHxM9f5U_Y_rOrN {
	display: flex;
	flex-direction: column;
	gap: var(--lok-spacing-2);
}

.mKeJBqibEU0pyncC {
	width: 500px;
	min-height: 538px;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Step/Step.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,yBAAyB;CACzB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,OAAO;AACR;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,qCAAqC;CACrC,yCAAyC;AAC1C;;AAEA;CACC,8CAA8C;CAC9C,yCAAyC;AAC1C;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB","sourcesContent":[".container {\n\tdisplay: flex;\n\tgap: var(--lok-spacing-7);\n\tpadding: var(--lok-spacing-7);\n}\n\n.contents {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-6);\n\tflex: 1;\n}\n\n.titleContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-4);\n}\n\n.title {\n\tfont: var(--lok-typography-heading-3);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.subtitle {\n\tfont: var(--lok-typography-body-small-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.footer {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\tgap: var(--lok-spacing-3);\n\theight: 100%;\n}\n\n.controlsContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: var(--lok-spacing-2);\n}\n\n.rsp {\n\twidth: 500px;\n\tmin-height: 538px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `q75caQFkGHgoxdMk`,
	"contents": `BVc_Eh0Ty2k_vSPL`,
	"titleContainer": `Xp1eN7zzigcc_eVh`,
	"title": `swWIjXp63JI1F3oo`,
	"subtitle": `_2Z1GwAfS_QavHFZ`,
	"footer": `fCX4XNQTaUcXOPRh`,
	"controlsContainer": `GWHxM9f5U_Y_rOrN`,
	"rsp": `mKeJBqibEU0pyncC`
};
export default ___CSS_LOADER_EXPORT___;
